<template>
  <div>
    <div class="ei-carousel" :style="{height:clientHeight+'px'}">
      <div :class="['ei-carousel-item',item.show?'item-show':'',item.hide?'item-hide':'']"
           :style="{zIndex:item.zIndex}"
           v-for="(item,index) in carousels" :key="index" @click="toWorksDetail()"
      >
        <!-- 背景图：只有已加载的索引才渲染真实 src -->
        <img v-if="loadedIndexes.includes('bg-' + index)" class="ei-carousel-bg" :src="oneBg.url"/>
        <img v-else class="ei-carousel-bg" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"/>

        <!-- 每项对应的背景图 -->
        <img v-if="loadedIndexes.includes('bgimg-' + index)" class="ei-carousel-image-bg" :src="bgurl"/>
        <img v-else class="ei-carousel-image-bg" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"/>

        <!-- 主图：懒加载核心 -->
        <img v-if="loadedIndexes.includes('main-' + index)"
             :src="item.url"
             :class="{'ei-carousel-image':true,'image-style':item.moreStyle===1}"
             loading="lazy"
             @load="onImgLoad(index)"/>
        <img v-else
             class="ei-carousel-image"
             src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"/>

        <div class="left-tipbg" v-if="leftDescription.indexOf('@')!==-1"><span
            class="s1">{{ leftDescription1 }}</span><span
            class="s2">{{ leftDescription2 }}</span><span
            class="s3 s3-small">{{ leftDescription3 }}</span><span
            class="s4">{{ leftDescription4 }}</span></div>
        <div class="left-tipbg" v-else><span
            class="s1">{{ leftDescription1 }}</span><span
            class="s2">{{ leftDescription2 }}</span><span
            class="s3">{{ leftDescription3 }}</span></div>
        <div class="midden-tipbg">{{ rightDescription === 'null' ? '' : rightDescription }}</div>
        <div class="midden2-tipbg">{{ middenDescription2 === 'null' ? '' : middenDescription2 }}</div>
        <div class="midden3-tipbg">{{ middenDescription4 === 'null' ? '' : middenDescription4 }}</div>
        <div class="midden4-tipbg">{{ middenDescription3 === 'null' ? '' : middenDescription3 }}</div>
      </div>
      <div class="ei-carousel-nav">
        <div :class="{'left-tip anim-opacity0-1s':true,'active1':active1}">{{ leftTip }}</div>
        <div class="nav-content">
          <div class="prev" @click="changeCarouselItemPrev"></div>
          <ei-indicator :order="order" :total="carousels.length" :animated="animated"></ei-indicator>
          <div class="next" @click="changeCarouselItemNext"></div>
        </div>
        <div :class="{'right-tip anim-opacity0-1s':true,'active1':active1}">{{ rightTip }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EiCarousel',
  props: {
    carousels: {
      type: Array,
      required: true
    },
    homeCarouselBgList: {
      type: Array,
      required: true
    },
    oneBg: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      color0: false,
      color1: false,
      color2: false,
      index: 0,
      firstTime: true,
      clientHeight: `${document.documentElement.clientHeight}`,
      internal: null,
      order: 1,
      animated: true,
      leftTip: '',
      rightTip: '',
      leftDescription: '',
      leftDescription1: '',
      leftDescription2: '',
      leftDescription3: '',
      leftDescription4: '',
      rightDescription: '',
      middenDescription2: '',
      middenDescription3: '',
      middenDescription4: '',
      active1: false,
      bgurl: '',
      bgindex: 0,
      linkid: '',
      // ===== 懒加载新增 =====
      loadedIndexes: [],   // 已经加载过真实 src 的索引集合
      preloadIndex: -1,    // 下一张预加载索引
    }
  },
  created () {
  },
  mounted () {
    let that = this
    window.onresize = function () {
      that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
    }
  },
  watch: {
    //正确给 Data 赋值的 方法
    carousels: function (newVal, oldVal) {
      this.carousels = newVal
      if (this.carousels.length > 0 && this.firstTime) {
        this.firstTime = false
        // 首屏只加载第 0 张和预加载第 1 张
        this.markLoaded(0)
        this.changeCarouselItem(this.index)
        this.initTimer()
      }
    },

  },
  methods: {
    // ===== 懒加载相关 =====
    /**
     * 标记某个索引需要加载真实图片
     * 同时更新背景图（bgurl 是按 bgindex 递推的，这里同步标记）
     */
    markLoaded (index) {
      if (index < 0 || index >= this.carousels.length) return
      const keys = [`main-${index}`, `bgimg-${index}`, `bg-${index}`]
      keys.forEach(k => {
        if (!this.loadedIndexes.includes(k)) {
          this.loadedIndexes.push(k)
        }
      })
    },
    /**
     * 图片加载完成回调
     * 可以在这里做骨架屏淡出、错误兜底等
     */
    onImgLoad (index) {
      // 可在此处做统计或动画，比如 fade-in
    },

    indexstrRight (str) {
      this.rightDescription = str.substring(0, str.lastIndexOf('='))
      let strx = str.substring(str.lastIndexOf('=') + 1)
      this.middenDescription2 = strx.substring(0, strx.lastIndexOf('*'))
      this.middenDescription3 = strx.substring(strx.lastIndexOf('+') + 1)
      let xx = strx.substring(strx.lastIndexOf('*') + 1)
      this.middenDescription4 = xx.substring(0, xx.lastIndexOf('$'))
    },

    indexstrLeft (str) {
      let left2 = str.substring(0, str.lastIndexOf('='))
      this.leftDescription1 = left2.substring(0, str.lastIndexOf('+'))
      this.leftDescription2 = left2.substring(left2.lastIndexOf('+') + 1)
      if (str.indexOf('@') !== -1) {
        let left4 = str.substring(str.lastIndexOf('=') + 1)
        this.leftDescription3 = left4.substring(0, left4.lastIndexOf('@'))
        this.leftDescription4 = str.substring(str.lastIndexOf('@') + 1)
      } else {
        this.leftDescription3 = str.substring(str.lastIndexOf('=') + 1)
      }

    },
    toWorksDetail () {
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: this.linkid },
      })
    },
    linidmethod () {
      this.linkid = ''
      this.linkid = this.carousels[this.index].link
    },
    initTimer () {
      this.internal = setInterval(() => {
        this.changeCarouselItem(this.index)
      }, 5000)
    },
    changeCarouselItem (index) {
      this.animated = false
      setTimeout(() => {
        this.animated = true
      }, 50)
      if (this.carousels != null || this.homeCarouselBgList != null) {
        this.bgurl = ''
        this.bgurl = this.homeCarouselBgList[this.bgindex].url
        this.bgindex++
        if (this.bgindex > this.homeCarouselBgList.length - 1) {
          this.bgindex = 0
        }
      } else {
        this.bgurl = '/upload/indexCarouselBg/976e319b-5a38-4735-aa11-01b63fde1ccf.png'
      }
      let preIndex = this.getPreIndex(index)
      this.order = index + 1

      // ===== 懒加载：确保当前索引与下一张索引被标记加载 =====
      this.markLoaded(index)
      const nextForPreload = this.getNextIndex(index)
      this.preloadIndex = nextForPreload
      // 下一张通过 requestIdleCallback 空闲加载，避免抢占首屏带宽
      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => this.markLoaded(nextForPreload))
      } else {
        setTimeout(() => this.markLoaded(nextForPreload), 800)
      }
      // ========================================================

      this.$set(this.carousels[preIndex], 'hide', true)
      this.$set(this.carousels[preIndex], 'show', false)
      this.$set(this.carousels[preIndex], 'zIndex', 0)
      this.linidmethod()
      this.index = this.getNextIndex(index)
      this.$set(this, 'active1', false)
      setTimeout(() => {
        this.$set(this, 'leftTip', this.carousels[index].leftTip)
        this.$set(this, 'rightTip', this.carousels[index].rightTip)
        this.$set(this, 'leftDescription', this.carousels[index].leftDescription ? this.carousels[index].leftDescription : '')
        if (this.carousels[index].rightDescription) {
          this.indexstrRight(this.carousels[index].rightDescription)
        } else {
          this.rightDescription = ''
          this.middenDescription2 = ''
          this.middenDescription3 = ''
          this.middenDescription4 = ''
        }
        if (this.carousels[index].leftDescription !== 'null' && this.carousels[index].leftDescription) {
          this.indexstrLeft(this.carousels[index].leftDescription)
        } else {
          this.leftDescription1 = ''
          this.leftDescription2 = ''
          this.leftDescription3 = ''
          this.leftDescription4 = ''
        }
        this.$set(this, 'active1', true)
        this.$set(this.carousels[index], 'zIndex', -1)
        this.$set(this.carousels[index], 'show', true)
        setTimeout(() => {
          this.$set(this.carousels[preIndex], 'hide', false)
          this.$set(this.carousels[index], 'behind', false)
        }, 1000)
      }, 300)
    },
    changeCarouselItemPrev () {
      clearInterval(this.internal)
      this.index = this.getPreIndex(this.index)
      let index = this.index
      // 切换前把上一张标记为已加载
      this.markLoaded(this.getPreIndex(index))
      this.markLoaded(index)
      this.$set(this.carousels[index], 'hide', true)
      this.$set(this.carousels[index], 'show', false)
      this.$set(this.carousels[index], 'zIndex', 0)
      setTimeout(() => {
        this.$set(this.carousels[index], 'zIndex', -1)
        this.$set(this.carousels[index], 'hide', false)
      }, 300)
      this.index = this.getPreIndex(this.index)
      this.changeCarouselItem(this.index)
      this.initTimer()
    },
    changeCarouselItemNext () {
      clearInterval(this.internal)
      this.changeCarouselItem(this.index)
      this.initTimer()
    },
    getNextIndex (index) {
      if (index < this.carousels.length - 1) {
        index++
      } else {
        index = 0
      }
      return index
    },
    getPreIndex (index) {
      if (index === 0) {
        index = this.carousels.length - 1
      } else {
        index--
      }
      return index
    },
    stopMouseDown2 (e) {
    }
  },
}
</script>

<style scoped lang="scss">
@import "../eiuov-ui/css/ei-anim";


.image-style {
  animation: image-stylex 5s linear infinite;
}

@keyframes image-stylex {
  to {
    filter: hue-rotate(360deg);
  }
}


.ei-carousel {
  position: relative;
  width: 100%;
  height: 700px;
  overflow: hidden;

  .ei-carousel-item {
    width: 100%;
    height: 100%;
    position: absolute;
    transform: scale(1, 1);
    opacity: 0;
    cursor: pointer;


    .left-tipbg {
      position: absolute;
      top: 185px;
      left: 225px;
      width: 1500px;
      height: 650px;
      font-weight: bolder;
      text-align: left;
      font-family: SimHei;
      cursor: pointer;
      white-space: pre-wrap;
      writing-mode: vertical-rl;
      color: #e50205;

      // 左侧竖排文字字号（px 由 postcss 自动转 vw）
      .s1 {
        font-size: 45px;
        line-height: 50px;
      }

      .s2 {
        font-size: 38px;
        line-height: 50px;
      }

      .s3 {
        font-size: 38px;
        line-height: 50px;
      }

      .s3-small {
        font-size: 25px;
        line-height: 26px;
      }

      .s4 {
        font-size: 38px;
        line-height: 50px;
      }

      /*   color: rgb(0,76,158);
         -webkit-background-clip: text;
         text-shadow: 0.2px 0.5px 0.4px rgb(0,127,238),
         0.2px 0.6px 0.5px rgb(0,127,238),
         0.2px 0.7px 0.6px rgb(0,127,238),
         0.2px 0.8px 0.7px rgb(0,103,200),
         0.2px 1px 1px white;*/
    }

    .midden-tipbg {
      position: absolute;
      margin-top: 283px;
      margin-left: 140px;
      width: 1750px;
      height: 645px;
      line-height: 50px;
      font-size: 45px;
      font-family: fantasy;
      cursor: pointer;
      white-space: pre-wrap;
      font-weight: bolder;
      color: #1141ec;
      /*text-shadow: black .005em 0 0, #cecece 0 .015em 0, #cecece -.025em 0 0, black 0 -.01em 0;*/
      text-shadow: black .03em 0 0, white -.02em 0 0, black 0 -.03em 0;
    }

    .midden2-tipbg {
      position: absolute;
      margin-top: 387px;
      margin-left: 140px;
      width: 2000px;
      height: 645px;
      line-height: 50px;
      letter-spacing: 2px;
      font-weight: bolder;
      font-size: 160px;
      font-family: fantasy;
      cursor: pointer;
      white-space: pre-wrap;
      color: #9F8F37;
      text-shadow: black .02em 0 0, white 0 .02em 0, white -.02em 0 0, black 0 -.02em 0
    }

    .midden3-tipbg {
      position: absolute;
      margin-top: 470px;
      margin-left: 590px;
      width: 1400px;
      height: 645px;
      line-height: 50px;
      font-weight: bolder;
      font-size: 80px;
      font-family: fantasy;
      cursor: pointer;
      white-space: pre-wrap;
      color: #9F8F37;
      text-shadow: black .02em 0 0, white 0 .02em 0, white -.02em 0 0, black 0 -.02em 0
    }

    .midden4-tipbg {
      position: absolute;
      margin-top: 623px;
      margin-left: 140px;
      width: 1750px;
      height: 645px;
      line-height: 50px;
      font-size: 45px;
      font-family: fantasy;
      /* transform: scale(0.9,0.9);*/
      cursor: pointer;
      white-space: pre-wrap;
      color: #e50205;
      font-weight: bolder;
      /* text-shadow: black .005em 0 0, #cecece 0 .015em 0,#cecece -.025em 0 0, black 0 -.01em 0;*/
      text-shadow: black .03em 0 0, white -.02em 0 0, black 0 -.03em 0;
    }


    .ei-carousel-bg {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .ei-carousel-image {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .ei-carousel-image-bg {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .ei-carousel-item.item-show {
    transform: scale(1.2, 1.2);
    z-index: 0;
    transition: transform 5000ms linear 0s;
    animation: item-show 5s linear;
  }

  @keyframes item-show {
    0% {
      opacity: 0.1
    }
    20% {
      opacity: 1
    }
    100% {
      opacity: 1
    }
  }

  .ei-carousel-item.item-hide {
    transform: scale(1.5, 1.5);
    z-index: 0;
    transition: opacity 1000ms cubic-bezier(0.5, 0, 0.2, 1) 0s,
    transform 1000ms cubic-bezier(0.5, 0, 0.2, 1) 0s;
    animation: item-hide 1s linear;
  }

  @keyframes item-hide {
    0% {
      opacity: 1
    }
    10% {
      opacity: 0.8
    }
    20% {
      opacity: 0.5
    }
    100% {
      opacity: 0
    }
  }

  .ei-carousel-item.item-behind {
    z-index: -1;
  }

  .ei-carousel-nav {
    position: absolute;
    display: flex;
    justify-content: center;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100%;
    height: 85px;
    background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);


    .left-tip {
      width: 950px;
      line-height: 85px;
      color: #ffffff;
      font-size: 30px;
      text-align: center;
      font-family: "仿宋";
      cursor: pointer;
    }

    .right-tip {
      width: 950px;
      text-align: center;
      text-indent: 100px;
      height: 85px;
      line-height: 85px;
      color: #ffffff;
      font-size: 30px;
      font-family: "仿宋";
      cursor: pointer;
    }

    .nav-content {
      display: flex;
      justify-content: center;
    }

    .ei-indicator {
      margin-top: 7px;
    }

    .prev {
      position: relative;
      background: url(./image/arrow-l.png) center center no-repeat;
      width: 19px;
      height: 85px;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      margin-right: 20px;
    }

    .next {
      position: relative;
      background: url(./image/arrow-r.png) center center no-repeat;
      width: 19px;
      height: 85px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 20px;
      cursor: pointer;
    }
  }
}

* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>